export default (_, children) => [...children]
